import { isStreamIQ, isToya } from '@/shared/lib'

export const getUseFavoritesHook = async () => {
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/features/Favorites/useFavoritesChannels')

            return module.default
        } catch (error) {
            console.warn(
                'useFavoritesChannelsStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/features/favourites/useFavoritesChannelsTOYA')
            return module.default
        } catch (error) {
            console.warn(
                'useFavoritesChannelsTOYA module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }

    throw new Error('Unknown API type')
}
